<template>
  <div class="poll-progress-wrap" v-if="data">
    <div class="contents">
      <div class="row" v-for="(item,i) in display" :key="i">
        <div class="bubble" :class="{selected: isThisRowSelected(i)}">{{i+1}}</div>
        <div class="name">{{item}}</div>
      </div>
    </div>
  </div>  
</template>

<script>
export default {
  props: {
    data: {
      /**
       * currentIndex
       * arr
       */
      type: Object,
      required: true
    }
  },
  computed: {
    display () {
      return this.data.arr.filter(el => el !== undefined)
    }
  },
  methods: {
    isThisRowSelected (index) {
      let countDiff = 0
      for (let i = 0; i <= index+1; i++) {
        const dataEl = this.data.arr[i];
        if (!dataEl) countDiff++
      }
      // console.log(this.data.currentIndex, countDiff, index);
      return (this.data.currentIndex - countDiff) === index
    }
  }
}
</script>

<style scoped lang='scss'>
.poll-progress-wrap {
  width: 250px;
  min-height: 100px;
  padding: 10px;
}
.contents {
  display: flex;
  flex-direction: column;
  .row {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    &:not(:first-child) {
      margin-top: 30px;
    }
    &:first-child:last-child {
      .bubble.selected::after{
        display: none;
      }
    }
    &:last-child {
      .bubble.selected::after{
        bottom: unset;
        top: -22px;
      }
    }
    .name {
      font-family: 'Poppins';
      // font-style: normal;      
      font-weight: 400;
      color: black;
    }
    .bubble {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 25px;
      height: 25px;
      border-radius: 50%;
      font-size: 16px;
      font-weight: 100;
      background: transparent;
      color: rgba(0, 0, 0, 0.9);
      border: 1px solid rgba(0, 0, 0, 0.2);
      &.selected {
        background: #1890FF;
        color: rgb(255, 255, 255);
        border: none;
        position: relative;
        &::after {
          position: absolute;
          content: '';
          width: 1px;
          height: 15px;
          background: #1890FF;
          left: 12px;
          bottom: -22px;
        }
      }
    }
  }
}
</style>